import { API_VERSION } from '@/utils/constants/commonConstants';
import { HTTP_METHODS } from '@/utils/constants/httpMethods';

export const REWARD_CATALOG_CONFIG = {
  REWARD_CATALOG: (queryParams) => ({
    endPoint: `rewards/list?${queryParams}`,
    method: HTTP_METHODS.POST,
    version: API_VERSION.V1,
    // mockData: RewardCatalogListMockData,
  }),
  
  // REVIEW_REWARD_CATALOG: {
  //   endPoint: 'reward-catalog',
  //   method: HTTP_METHODS.POST
  // },
  REWARD_CATALOG_CSV_DOWNLOAD: (queryParams) => ({
    endPoint: `rewards/download${queryParams ? `?${queryParams}` : ''}`,
    method: HTTP_METHODS.POST,
  }),
  REWARD_CATALOG_TEMPLATE_DOWNLOAD: () => ({
    endPoint: `template/reward-catalog`,
    method: HTTP_METHODS.GET,
  }),
  REWARD_CATALOG_BULK_UPLOAD: () => ({
    endPoint: `rewards/bulk-upload`,
    method: HTTP_METHODS.POST,
  }),
};
